//subscriptions.ts

import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";

export const subscriptionsApi = {
  post: (data: { action: string }): Promise<{ url?: string }> =>
    apiProvider
      .post("subscriptions", { data })
      .then((d?: JsonDocument<{ url?: string }>) => (d ? d.data : {})),
};
